<template>
  <div id="product" class="animated fadeIn pb4">
    <!-- desktop view -->
    <div>
      <WebshopHeader>
      </WebshopHeader>
      <div class="clearfix" v-if="loading">
        <div class="col-12">
          <div class="loader"></div>
        </div>
      </div>
      <div class="pt4 px3" v-else>
        <div class="lg-col-6 mr3 p0 pt2">
          <span class="h4 darkblue bold">{{prodData.NAME}}</span>
        </div>
        <div class="lg-flex">
          <div class="lg-col-6 mr3 p0">
            <div class="">
              <div class="clearfix" v-if="insideLoading">
                <div class="col-12 center">
                  <div class="loader"></div>
                  <p class="mediumgrey bold">Genererer forhåndsvisning...</p>
                </div>
              </div>
              <el-carousel class="hide" :autoplay="false" :loop="false" arrow="always" indicator-position="none" height="600px" @change="setHeightCarousel()">
                <el-carousel-item v-for="(img,index) in prodImg" :key="index" v-if="prodData.CATEGORY_ID !== 205"  >
                  <div class="flex justify-center white-background">
                    <img :data-key="index"
                        :src="typeof 'http://widget.haandvaerker.dk/products/'+prodGroup+'/'+prodData.EXT+'/rendered/'+haaId+'.jpg' !== 'undefined' && 'http://widget.haandvaerker.dk/products/'+prodGroup+'/'+prodData.EXT+'/rendered/'+haaId+'.jpg' !== null ? 'http://widget.haandvaerker.dk/products/'+prodGroup+'/'+prodData.EXT+'/rendered/'+haaId+'.jpg' : 'http://widget.haandvaerker.dk/products/'+prodGroup+'/'+prodData.EXT+'/productPng.php?id='+haaId"
                        width="100%" :class="'prod-img catId-'+prodData.CATEGORY_ID" rel="preload"
                        @load="ImageFound(index, prodImg.length)" v-if="prodGroup == '1000' || prodGroup == '1300' || prodGroup == '1400' || prodGroup == '2000' || prodGroup == '2100' || prodGroup == '2200' || prodGroup == '2300' || prodGroup == '2400' || prodGroup == '2500' || prodGroup === '10001' || prodGroup === '10002' || prodGroup == '10003' || prodGroup == '10004' || prodGroup == '10005' ">
                    <!-- <video class="prod-img" width="100%" @loadstart="setHeightCarousel()" controls autoplay v-else-if="prodGroup == '8000' && prodData.WEBSITE.includes('videos')">
                      <source :src="prodData.WEBSITE" type="video/mp4">
                    </video> -->
                    <img id="imagefcrm" :src="'https://newcrm.kundematch.dk'+prodImg[index].showURL"
                      width="100%" rel="preload" class="prod-img" @load="ImageFound(index, prodImg.length)" v-else>
                  </div>
                </el-carousel-item>
                <!--  Widget Prisen -->
                <el-carousel-item v-else>
                  <div class="flex justify-center white-background">
                    <!-- Widget prisen -->
                    <img :data-key="0"
                      :src="prodImage.VALUE"
                      width="50%" :class="'prod-img imgId-0'" rel="preload" @load="ImageFound(0, 2)" @error="setImage(0, 'streamer/streamerPng', 0)" v-for="prodImage in prodData.get_element_property" v-if="prodImage.IBLOCK_PROPERTY_ID == 429">
                  </div>
                </el-carousel-item>
                <el-carousel-item v-if="prodData.CATEGORY_ID === 205">
                  <div class="flex justify-center white-background">
                    <!-- Widget prisen -->
                    <img :data-key="1"
                    :src="prodImage.VALUE.replace('streamer', 'bladder')" width="100%" :class="'prod-img imgId-1'" rel="preload" @load="ImageFound(1, 2)" @error="setImage(1, 'bladder/bladderPng', 1)" v-for="prodImage in prodData.get_element_property" v-if="prodImage.IBLOCK_PROPERTY_ID == 429">
                  </div>
                </el-carousel-item>
                <!-- <Byggepladsskilt v-if="prodId==='9548' "></Byggepladsskilt>
                <Traadhegns v-if="prodId==='9652' "></Traadhegns>
                <Rullestillads v-if="prodId==='9653' "></Rullestillads>
                <Facadestillads v-if="prodId==='9655' "></Facadestillads>
                <Byggepladshegn v-if="prodId==='9654' "></Byggepladshegn> -->
              </el-carousel>
            </div>
            <div class="pb3"></div>
          </div>
          <div class="lg-col-5 mx-auto">
            <b-form :model="ruleForm">
              <div class="flex col-12 my2 p0" v-if="dontshowproduct">
                <span class="h5 bold ml-auto flex items-center col-6 p0 ">Antal:</span>
                <b-form-input v-model="qty" type="number" min="1" value="1" class="qty col-6 mr-auto" @keyup="quantityChanged(prodData.PRICE)" @change="quantityChanged(prodData.PRICE)"></b-form-input>
              </div>
              <div class="flex mt3 col-12 p0" v-else><p class="col-12 h5 mr-auto mr2 m0 p0 ">Du har allerede dette produkt i din indkøbskurv</p></div>
              <div class="flex mt3 col-12 p0" v-if="dontshowneedhelp">
                <span class="h5 bold col-6 ml-auto p0 m0">Brug for grafisk hjælp?</span>
                <b-form-group class="col-6 mr-auto p0" :value.sync="needhelp" v-slot="{ ariaDescribedby }">
                  <b-form-checkbox-group >
                    <b-form-checkbox class="line-height-2 mb2" v-model="needhelp" @change="updateprice()" :aria-describedby="ariaDescribedby" name="sortByDate" >
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </div>
              <div class="flex mt3 col-12 p0 " v-else><p class="col-12 h5 mr-auto mr2 m0 p0">Du har allerede brug for hjælp grafik til dette produkt i din indkøbskurv</p></div>
              <div class="flex col-12 my3  p0 " v-if="dontshowproduct">
                <span class="col-6 h5 bold ml-auto p0">Pris:</span>
                <span id="price" class="flex col-6 h4 bold mr-auto items-center m0 p0">{{subtotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}}<p class="ml1 bold m0"> kr</p></span> 
              </div>
              <!-- <span class="h6 bold">Vælg antal:</span>
              <div class="pb2"></div>
              <v-select v-model="varation" :options="optionsData" placeholder="Vælg antal" class="border muted-border" @input="varationChanged()">
              </v-select>
              <div class="pb2"></div>
              <span class="h6 bold">Upload dit logo:</span>
              <div class="pb2"></div>
              <file-upload-input token="" module="" @UpdateTilbud="handleFileUpload"></file-upload-input> -->
              <div class="pb2"></div>
              <div>
                <b-button type="button" class="action-button py2 px3 m0 line-height-1 gibson not-rounded border-none regular" @click="addCart()" v-if="dontshowproduct">TILFØJ TIL KURVEN <i class="el-icon-right"></i></b-button>
                <b-button type="button" class="action-button py2 px3 m0 line-height-1 gibson not-rounded border-none regular" @click="updatecart()" v-else>OPDATER INDKØBSVOGN<i class="el-icon-right"></i></b-button>
              </div>
            </b-form>
            <h6 class="bold mt3">Beskrivelse:</h6>
            <p id="proddesc" class="gibson" v-html="prodData.DESCRIPTION"></p>
          </div>
        </div>
        <!-- <div>
          <span class="h4 my2 center col col-12">Upload din pdf her <h6>kun en pdf-fil accepteres her</h6></span>
          <b-form-group id="file" label="" label-for="fag" class="p0 form-group  form-group lg-col-12 md-col-12    ">
            <file-upload-input-pdfonly token="" module=""  @UpdateTilbudpdf="handleFileUploadpdf" class="education-upload"></file-upload-input-pdfonly>
          </b-form-group>
        </div> -->
      </div>
      <WebshopFooter v-if="!loading">
      </WebshopFooter>
    </div>
  </div>
</template>

<script>
import WebshopHeader from './header'
import WebshopFooter from './footer'
import vSelect from 'vue-select'
import FileUploadInputPdfonly from '../../../components/file-upload-input-pdfonly.vue'
// import PHPUnserialize from 'php-unserialize'
import fileUploadInput from '../../../components/file-upload-input'
import Byggepladsskilt from './products/byggepladsskilt'
import Traadhegns from './products/Traadhegns'
import Rullestillads from './products/Rullestillads'
import Facadestillads from './products/Facadestillads'
import Byggepladshegn from './products/Byggepladshegn'
export default {
  name: '',
  components: {
    WebshopHeader,
    WebshopFooter,
    vSelect,
    fileUploadInput,
    Byggepladsskilt,
    Traadhegns,
    Rullestillads,
    Facadestillads,
    Byggepladshegn,
    FileUploadInputPdfonly
  },
  data () {
    return {
      loading: true,
      needhelp: false,
      needhelpamount: '',
      subtotal: 0,
      subtotalqty: 0,
      dontshowproduct: true,
      dontshowneedhelp: true,
      cartneedhelp: [],
      cartprod: [],
      insideLoading: true,
      totalProdCount: 0,
      salesPerson: '',
      haaId: '',
      prodData: [],
      prodId: '',
      prodImg: [],
      uploadedpdf: [],
      // optionsData: [],
      // fileList: [],
      prodGroup: '',
      qty: 1,
      priceIfQtyEQ2: '',
      priceIfQtyEQGT3: '',
      // varation: '',
      ruleForm: {
      }
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    this.displayProductInfo()
  },
  methods: {
    checkifneedhelpisincart (needhelpname) {
      var needhelpnames = needhelpname.trim() + '-Brugforhjælp'
      var prodname = needhelpname.replace(/\s+/g, '').trim()
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetCart/' + this.haaId + '?page=' + this.curPage
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (typeof res !== 'undefined' && res !== null && res.success) {
            var dataRes = response.data.data.data[0].webshop_cart_products
            this.cartneedhelp = dataRes.filter((a) => {
              var nametempe = a.PRODUCT_NAME.replace(/\s+/g, '').trim().split('-')[0] + '-' + a.PRODUCT_NAME.replace(/\s+/g, '').trim().split('-')[1]
              if (nametempe === needhelpnames) {
                return a
              }
            })
            this.cartprod = dataRes.filter((a) => {
              var nametempeprod = a.PRODUCT_NAME.replace(/\s+/g, '').trim()
              if (nametempeprod === prodname) {
                return a
              }
            })
            if (this.cartneedhelp.length >= 1) {
              this.dontshowneedhelp = false
            }
            if (this.cartprod.length >= 1) {
              this.dontshowproduct = false
            }
          } else {
            console.log('Error in displayCart()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    currentdate () {
      const current = new Date()
      const date = current.getFullYear() + '-' + (current.getMonth() + 1) + '-' + current.getDate()
      return date
    },
    showBreadCrumb () {
      document.querySelector('.breadCrumb').classList.remove('hide')
    },
    displayProductInfo () {
      var urlStr = window.location.href
      var url = new URL(urlStr.replace('/#', ''))
      var searchParams = url.searchParams
      var id = searchParams.get('id')
      this.prodId = id
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetProducts/' + id + '/0/0'
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var dataRes = response.data.data[0]
            this.getallproductbycat(dataRes.CATEGORY_ID)
            this.checkifneedhelpisincart(dataRes.NAME)
            // var varation = ''
            var imgs = []
            var defaultprod = {
              'ID': 8903,
              'IBLOCK_PROPERTY_ID': 98,
              'IBLOCK_ELEMENT_ID': 11682,
              'VALUE': '3502',
              'TIMESTAMP_X': '2022-01-26 13:16:00',
              'CONTENT_TYPE': 'image/jpeg',
              'HEIGHT': 788,
              'WIDTH': 732,
              'FILE_SIZE': 47521,
              'FILE_NAME': '40035 4.jpg',
              'ORIGINAL_NAME': '40035 4.jpg',
              'SUBDIR': 'iblock/e64/fofm5650a15jentoqk6xeuzxyucar8mx',
              'showURL': '/upload/iblock/e64/fofm5650a15jentoqk6xeuzxyucar8mx/40035 4.jpg'
            }
            if (response.data.data.length) {
              imgs = response.data.data[0].get_product_image
              if (imgs.length === 0) {
                imgs.push(defaultprod)
              }
            } else {
              imgs = ''
            }
            this.loading = false
            var group = response.data.data[0].PRODUCT_GROUP
            var priceQtyEQ2 = response.data.data[0].PRICE_IF_QTYEQ2
            var priceQtyEQgt3 = response.data.data[0].PRICE_IF_QTYEQGT3
            // if (dataRes.CATEGORY_ID === 101) {
            //   varation = dataRes.NUMBER_VARIATION.split(',')
            // } else {
            //   varation = dataRes.SIZE_VARIATION.split(',')
            // }
            // var arr = []
            // var varData = ''
            // for (var i = 0; i < varation.length; i++) {
            //   var obj = {}
            //   varData = varation[i].split(':')
            //   obj.label = varData[0]
            //   obj.value = varData[1]
            //   arr.push(obj)
            // }
            // this.optionsData = arr
            this.needhelpamount = parseInt(response.data.data[0].PDF_UNIT_PRICE.split('|')[0])
            this.prodData = dataRes
            this.subtotal = parseInt(dataRes.PRICE)
            this.subtotalqty = parseInt(dataRes.PRICE)
            this.prodImg = imgs
            this.prodGroup = group
            this.priceIfQtyEQ2 = priceQtyEQ2
            this.priceIfQtyEQGT3 = priceQtyEQgt3
            if (this.prodData.SIZE === '') {
              this.prodData.EXT = '0'
            } else {
              this.prodData.EXT = this.prodData.SIZE.replace(/\s/g, '').replaceAll('B', '').replaceAll('H', '')
            }
            this.prodData.LOAD = true
            this.showBreadCrumb()
            this.insideLoading = false
          } else {
            this.showBreadCrumb()
            this.loading = false
            console.log('Error in displayProductInfo()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    updateprice () {
      if (this.needhelp.length === 1) {
        if (this.subtotalqty > 1) {
          this.subtotal = this.subtotalqty + this.needhelpamount
        } else {
          this.subtotal = parseInt(this.subtotal) + this.needhelpamount
        }
      }
      if (this.needhelp.length === 0) {
        this.quantityChanged(this.prodData.PRICE)
      }
    },
    quantityChanged (originalPrice) {
      // If product group is Bannere/Byggepladsskilte or streamers/stickers
      if (this.prodGroup === '2000' || this.prodGroup === '2100' || this.prodGroup === '2200' || this.prodGroup === '2300' || this.prodGroup === '10001' || this.prodGroup === '10002' || this.prodGroup === '10003' || this.prodGroup === '10004' || this.prodGroup === '10005') {
        var qty = parseInt(this.qty)
        var price = 0
        if (!isNaN(qty) && qty >= 1) {
          if (qty === 1) {
            price = parseInt(originalPrice)
          } else if (qty === 2) {
            price = (parseInt(this.priceIfQtyEQ2) * parseInt(this.qty))
          } else if (qty === 3) {
            price = (parseInt(this.priceIfQtyEQGT3) * parseInt(this.qty))
          } else {
            price = (parseInt(this.priceIfQtyEQGT3) * parseInt(this.qty))
          }
        } else {
          price = parseInt(originalPrice)
        }
        // if (Number.isInteger(price)) {
        //   price = price + '.00'
        // }
        // document.getElementById('price').innerText = price
        this.subtotalqty = price
        this.subtotal = this.subtotalqty
        this.updateprice()
      }
    },
    handleFileUploadpdf (file) {
      this.uploadedpdf = file
      console.log('sdsd', this.uploadedpdf)
    },
    // handleFileUpload (file) {
    //   this.fileList = file
    // },
    // varationChanged () {
    //   var data = {
    //     operation: 'bitrixApi',
    //     salesPerson: this.salesPerson,
    //     type: 'GET',
    //     url: 'webshop/GetProducts/' + this.varation.value + '/0/0'
    //   }
    //   this.$http.post('', data, { emulateJSON: true }).then(
    //     (response) => {
    //       var res = response.body
    //       if (res.login === false) {
    //         this.$router.push('/login')
    //       }
    //       if (res.success) {
    //         var dataRes = response.data.data.data[0]
    //         this.prodGroup = dataRes.PRODUCT_GROUP
    //       } else {
    //         console.log('Error in varationChanged()')
    //       }
    //     },
    //     (response) => {
    //       console.log('Error: ', response)
    //     }
    //   )
    // },
    setHeightCarousel () {
      this.insideLoading = true
      document.querySelector('.el-carousel').classList.add('hide')
      setTimeout(() => {
        document.querySelector('.el-carousel').classList.remove('hide')
        var img = document.querySelector('.el-carousel__item.is-active .prod-img').clientHeight
        document.querySelector('.el-carousel__container').style.height = img + 'px'
        this.insideLoading = false
      }, 1000)
    },
    ImageFound (index, length) {
      if (length - 1 === index) {
        this.setHeightCarousel()
      }
    },
    setImage (imgID, filePath, index) {
      var img = document.querySelector('.imgId-' + imgID)
      img.src = 'https://widget.haandvaerker.dk/prisen/winnersBadge/' + filePath + '.php?id=' + this.haaId
    },
    updatecart () {
      if (this.needhelp && this.needhelp.length !== 0) {
        this.addProductneedhelp(this.prodData.NAME, this.needhelpamount, this.prodData.CATEGORY_ID, this.prodData.PRODUCT_GROUP, 'https://newcrm.kundematch.dk' + this.prodData.get_product_image[0].showURL)
      } else {
        this.$router.push('/webshop/cart')
        this.$toastr('success', 'Tilføjet')
        this.loading = true
      }
    },
    addCart () {
      const compId = this.haaId
      const prodId = this.prodId
      // const logoFileList = this.fileList
      // var logo = []
      // for (var i = 0; i < logoFileList.length; i++) {
      //   var file = logoFileList[i]
      //   logo.push('https://www.kundematch.dk/HenttilbudImg.php?img=' + file)
      // }
      const qty = parseInt(this.qty)
      const prodGroup = this.prodGroup
      if (qty > 0) {
        var data = {
          operation: 'bitrixApi',
          salesPerson: this.salesPerson,
          type: 'POST',
          url: 'webshop/AddToCart/0',
          parameters: JSON.stringify({
            CompanyID: compId,
            ProductID: prodId,
            Quantity: qty,
            ProductGroup: prodGroup
          })
        }
        this.$http.post('', data, { emulateJSON: true }).then(
          (response) => {
            var res = response.body
            if (res.success) {
              if (this.needhelp && this.needhelp.length !== 0) {
                this.addProductneedhelp(this.prodData.NAME, this.needhelpamount, this.prodData.CATEGORY_ID, this.prodData.PRODUCT_GROUP, 'https://newcrm.kundematch.dk' + this.prodData.get_product_image[0].showURL)
              } else {
                this.$router.push('/webshop/cart')
                this.$toastr('success', 'Tilføjet')
                this.loading = true
              }
            } else {
              this.$toastr('error', 'Fejl')
              console.log('Error in addCart()')
            }
          },
          (response) => {
            console.log('Error: ', response)
          }
        )
        this.loading = true
      } else {
        this.$toastr('error', 'Mængden skal være større end nul')
      }
    },
    getallproductbycat (id) {
      // getting prod from this cat
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
        // operation: 'bitrixApi',
        // salesPerson: this.salesPerson,
        // type: 'GET',
        // url: 'webshop/GetProducts/0/0/' + catResess.ID
      }
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/webshop/GetProducts/0/0/' + id, data, { headers }, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var dataRes = response.data.data
            this.totalProdCount = dataRes.length
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
      // end of  getting prod from this cat   delete this if the product list is done
    },
    addProductneedhelp (productname, productprice, categoryid, prodgroup, prodimg) {
      var name = productname
      var index = categoryid
      var price = productprice
      var productgroup = prodgroup
      var productimage = prodimg
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'POST',
        url: 'webshop/AddProduct',
        parameters: JSON.stringify({
          // this currentdate() is to avoid duplicate in product name si they can continue add product
          product_name: name + ' - Brugforhjælp - ' + (parseInt(this.totalProdCount) + 1),
          product_price: price,
          supplier_id: this.haaId,
          badge_id: ' ',
          image_url: productimage,
          product_group: productgroup,
          category_id: index,
          description: 'Dette viser, at denne virksomhed har brug for hjælp til hans/hendes grafik til dette specifikke produkt',
          pdf_graphic_need: 'Yes',
          pdf_unit_price: price,
          pdf_url: ' '
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var data = {
              operation: 'bitrixApi',
              salesPerson: this.salesPerson,
              type: 'POST',
              url: 'webshop/AddToCart/0',
              parameters: JSON.stringify({
                CompanyID: this.haaId,
                ProductID: res.data.result,
                Quantity: 1,
                ProductGroup: productgroup
              })
            }
            this.$http.post('', data, { emulateJSON: true }).then(
              (response) => {
                var res = response.body
                if (res.success) {
                  this.$router.push('/webshop/cart')
                  this.$toastr('success', 'Tilføjet')
                  this.loading = true
                } else {
                  this.$toastr('error', 'Fejl')
                  console.log('Error in addCart()')
                }
              },
              (response) => {
                console.log('Error: ', response)
              }
            )
          } else {
            console.log('Error in addProduct()', response)
          }
        },
        (response) => {
          console.log('Error in addProduct()', response)
        }
      )
    }
  }
}
</script>
<style>
  #proddesc p {
    margin-bottom: 0px!important;
  }
  #product button.vs__clear {
    display: none;
  }
  #product .el-carousel__arrow {
    background-color: #00364563;
    border: 3px solid;
    height: 50px;
    width: 50px;
  }
  #product .el-carousel__arrow:hover {
    background-color: #003645;
  }
  #product .el-carousel__arrow i {
    font-weight: bold;
  }
  @media (max-width: 64em) {
    #product .lg-col-6.mr3 {
      margin-right: 0
    }
  }
  .custom-control-input {
      position: unset;
      z-index: 1;
      opacity: 1;
}
.custom-control {
    padding-left: 0px!important;
}
.image {
    width: 200px;
    height: 200px;
    background-size: contain;
    cursor: pointer;
    margin: 10px;
    border-radius: 3px;
}
.field-input {
  border-radius: 0!important;
  background: rgba(230, 234, 235, 0.5)!important;
  border:0!important;
}
</style>


// WEBPACK FOOTER //
// product.vue?2d6b6c3c